import * as angular from 'angular';

"use strict";

angular.module('PageBarModule', [])

export default 'PageBarModule';